module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/desktop@2x-736cff7a038629681fe7116f9c6dfe51.jpg";